export default __webpack_public_path__ + "locales/el-GR/Common.json?hash=3b90d1836d1c3abb1bca86c6a2556a10";